import {mapGetters, mapActions, mapMutations} from 'vuex'

import propertyCard from '@/components/properties-grid/property-card/index.vue'
import paginatorRequest from '@/components/paginator-request/index.vue'
import _ from "lodash";

export default {
  name: 'properties',
  props: {
    perPage: {
      type: Number,
      default: 12
    },
  },
  //---components
  components: {
    propertyCard,
    paginatorRequest
  },
  //---data
  data () {
    return {}
  },
  //---hooks
  computed: {
    ...mapGetters({
      listings: 'FILTERS/listings',
      filtersMeta: 'FILTERS/filtersMeta'
    }),
  },
  //---methods
  methods: {
    ...mapMutations({
      loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
    }),
    ...mapActions({
      getListings: 'FILTERS/FILTERS_LISTINGS_REQUEST_GET'
    }),
    getPage(pageId) {
      this.loaderFlag(true);
      let query = null
      if (pageId && pageId > 1) {
        query = Object.assign({}, this.$route.query, {page: pageId})
      } else {
        query = Object.assign({}, this.$route.query)
        delete query.page
      }



      this.$router.push({name: this.$route.name, query: query});

      this.getListings({filters: query, perPage: this.perPage}).finally(()=> {
        this.loaderFlag(false);
      });
    }
  }
}
